import type { ChunkMetadata } from "./types";

export type ChunkType = "text" | "table" | "image" | "other";

export function normalizeChunkType(type: string | undefined): ChunkType {
  const t = (type || "text").toLowerCase().trim();
  if (t === "table") return "table";
  if (t === "image") return "image";
  if (t === "text" || t === "equation") return "text";
  return "other";
}

export function getChunkTypeLabel(type: string | undefined): string {
  switch (normalizeChunkType(type)) {
    case "table":
      return "Tabella";
    case "image":
      return "Immagine";
    case "text":
      return "Testo";
    default:
      return "Estratto";
  }
}

export function getChunkModalTitle(type: string | undefined): string {
  switch (normalizeChunkType(type)) {
    case "table":
      return "Tabella citata";
    case "image":
      return "Immagine citata";
    default:
      return "Testo citato";
  }
}

/** Titolo da mostrare in sidebar e modale */
export function getChunkDisplayTitle(meta: ChunkMetadata): string {
  const candidates = [
    meta.header,
    meta.table_caption,
    meta.image_caption,
    meta.file_title,
  ];
  for (const c of candidates) {
    if (typeof c === "string" && c.trim()) return c.trim();
  }
  return `Chunk ${meta.chunk_id}`;
}

function hasText(value: string | undefined): boolean {
  return typeof value === "string" && value.trim().length > 0;
}

export function chunkHasDisplayContent(meta: ChunkMetadata): boolean {
  return (
    hasText(meta.header) ||
    hasText(meta.text) ||
    hasText(meta.resume) ||
    hasText(meta.table_caption) ||
    hasText(meta.table_body) ||
    hasText(meta.table_footnote) ||
    hasText(meta.image_caption) ||
    hasText(meta.image_description) ||
    hasText(meta.image_footnote)
  );
}

export function isHtmlTableContent(content: string): boolean {
  return /<\s*(table|thead|tbody|tr|td|th)[\s>]/i.test(content);
}
